"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalService = exports.ModalServiceImpl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const modal_style_1 = require("./modal.style");
class ModalServiceImpl {
    constructor() {
        this.CSS = modal_style_1.CSS;
        this.current = null;
        this._bindCtx = null;
    }
    get isOpen() {
        return this.current != null;
    }
    open(ctx) {
        //We want to make sure the filter is empty when opening a new modal
        services_1.Services.MultiListSearch.reset();
        if (this.isOpen) {
            let currentTitle = '';
            if (this.current != null) {
                currentTitle = this.current.ctx.title;
            }
            this.close(false);
            services_1.Logger.fatal({ newModal: ctx.title, old: currentTitle }, 'Open modal over existing modal');
        }
        this.eventContext.on(this.eventContext.Code.Escape, () => {
            if (ctx.canClose != null && ctx.canClose()) {
                this.close();
            }
        });
        // tslint:disable:promise-must-complete
        return new Promise((resolve, reject) => this.current = { resolve, reject, ctx });
    }
    setTitle(title) {
        if (this.current == null) {
            services_1.Logger.fatal('ModalService.setTitle called when modal is not open');
            return;
        }
        this.current.ctx.title = title;
    }
    get eventContext() {
        if (this._bindCtx == null) {
            this._bindCtx = services_1.Services.Input.getContext();
        }
        return this._bindCtx;
    }
    /**
     * Force close the current modal.
     *
     * This will resolve the open promise with the same action as "cancel being clicked"
     */
    close(isOk) {
        if (this.eventContext) {
            this.eventContext.destroy();
        }
        if (!this.isOpen) {
            return null;
        }
        const cancel = isOk == null || isOk === false;
        const ok = !cancel;
        const openPromise = this.current;
        this.current = null;
        openPromise.resolve({ ok, cancel });
        return false;
    }
    view() {
        if (!this.isOpen) {
            return null;
        }
        const ctx = this.current.ctx;
        let content;
        if (typeof ctx.content === 'function') {
            content = ctx.content();
        }
        else {
            content = ctx.content;
        }
        const onsubmit = (e) => {
            if (typeof ctx.onSubmit === 'function') {
                ctx.onSubmit();
            }
            e.preventDefault();
            return false;
        };
        return (0, mithril_1.m)('div', { className: modal_style_1.CSS.container + ' ' + modal_style_1.CSS.isOpen }, [
            (0, mithril_1.m)('form', { className: `${modal_style_1.CSS.modal} ${ctx.className || ''}`, onsubmit }, [
                (0, mithril_1.m)('div', { className: modal_style_1.CSS.title }, (0, i18n_1.Translate)(ctx.title)),
                (0, mithril_1.m)('div', { className: modal_style_1.CSS.content }, content),
                this.viewActions
            ])
        ]);
    }
    get viewActions() {
        const ctx = this.current.ctx;
        if (ctx.actions) {
            return (0, mithril_1.m)('div', { className: modal_style_1.CSS.actions }, typeof (ctx.actions) === 'function' ? ctx.actions() : ctx.actions);
        }
        const onCancelClick = _ => this.close(false);
        const onOkClick = _ => this.close(true);
        const buttons = [
            (0, mithril_1.m)('button', {
                className: modal_style_1.MDL.button + ' ' + modal_style_1.CSS.action.ok,
                onclick: onOkClick,
                type: 'submit',
                id: 'modal-ok'
            }, (0, i18n_1.Translate)(ctx.okName || i18n_1.T.OK))
        ];
        if (ctx.hasCancel) {
            buttons.unshift((0, mithril_1.m)('button', {
                className: modal_style_1.MDL.button + ' ' + modal_style_1.CSS.action.cancel,
                onclick: onCancelClick,
                type: 'button'
            }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)));
        }
        return (0, mithril_1.m)('div', { className: modal_style_1.CSS.actions }, buttons);
    }
}
exports.ModalServiceImpl = ModalServiceImpl;
tslib_1.__decorate([
    mobx_1.observable
], ModalServiceImpl.prototype, "current", void 0);
tslib_1.__decorate([
    mobx_1.computed
], ModalServiceImpl.prototype, "isOpen", null);
tslib_1.__decorate([
    mobx_1.action
], ModalServiceImpl.prototype, "open", null);
tslib_1.__decorate([
    mobx_1.action
], ModalServiceImpl.prototype, "setTitle", null);
tslib_1.__decorate([
    mobx_1.action
], ModalServiceImpl.prototype, "close", null);
tslib_1.__decorate([
    mobx_1.computed
], ModalServiceImpl.prototype, "viewActions", null);
exports.ModalService = new ModalServiceImpl();
//# sourceMappingURL=modal.service.js.map